import { defineNuxtPlugin } from '#app';
import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getAuth,} from 'firebase/auth';

export default defineNuxtPlugin(nuxtApp => {

	// Your web app's Firebase configuration
	const firebaseConfig = {
	apiKey: "AIzaSyDjUNZ4G_2SzIkzsElB-dBhxi4Mn-UH09o",
	authDomain: "cybercore-space.firebaseapp.com",
	databaseURL: "https://cybercore-space.firebaseio.com",
	projectId: "cybercore-space",
	storageBucket: "cybercore-space.appspot.com",
	messagingSenderId: "507726858692",
	appId: "1:507726858692:web:a3eeea2af5cee512ae3c91",
	measurementId: "G-6SPBWCX3V4"
	};
	
	const app =  initializeApp(firebaseConfig);
	const firestore = getFirestore(app);
	const auth = getAuth(app)
	const storage = getStorage(app)

	nuxtApp.vueApp.provide('firestore', firestore)
    nuxtApp.provide('firestore', firestore)
	nuxtApp.vueApp.provide('auth', auth)
    nuxtApp.provide('auth', auth)
	nuxtApp.vueApp.provide('storage', storage)
	nuxtApp.provide('storage', storage)

});